exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".users.inner-block .create-user,.users.inner-block .edit-user{padding:15px;margin-bottom:15px;background-color:#f4f6f8}.users.inner-block .create-user hr.separator,.users.inner-block .edit-user hr.separator{margin-bottom:25px;margin-top:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/panel/cloudAccounts.component/styles.less
 ** module id = 608
 ** module chunks = 0
 **/